import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import CreationMetadata from './CreationMetadata';
import CopyableText from '../../elements/copyable-text/CopyableText';

const Metadata = ({
  copyable = false,
  copyText,
  copyLabel,
  creator,
  createDate,
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      {copyable && <CopyableText text={copyText} label={copyLabel} />}
      <CreationMetadata author={creator} createDate={createDate} />
    </Box>
  );
};

Metadata.propTypes = {
  copyable: PropTypes.bool,
  copyText: PropTypes.string,
  copyLabel: PropTypes.string,
  creator: PropTypes.object.isRequired,
  createDate: PropTypes.string.isRequired,
};

export default Metadata;
